<template>
    <RadioGroup>
        <RadioGroupLabel class="sr-only">
            {{ title }}
        </RadioGroupLabel>
        <div>
            <div :class="(custom_class) ? custom_class : 'grid grid-cols-4 gap-4'">
                <RadioGroupOption as="template" v-for="(option, optionIdx) in options" :key="option.name" :value="option.value" v-slot="{ checked, active }" @click="$emit('input',$event.target.value)" :class="(optionIdx === 0) ? 'col-start-2' : ''">
                    <div :class="[active ? 'ring-2 ring-purple-700 ring-offset-2' : '', optionIdx === 0 ? 'sm:col-start-2' : '', checked ? 'bg-purple-700 text-white hover:bg-purple-500' : 'ring-1 ring-inset ring-gray-300 bg-white text-gray-900 hover:bg-gray-50', 'flex items-center justify-center rounded-md py-3 px-5 text-sm font-semibold uppercase sm:flex-1 hover:cursor-pointer']">
                        <RadioGroupLabel as="span">{{ option.name }} {{  }}</RadioGroupLabel>
                    </div>
                </RadioGroupOption>
            </div>
        </div>
    </RadioGroup>
</template>

<script>
import {RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption} from '@headlessui/vue'

export default {
    components: {
        RadioGroup,
        RadioGroupDescription,
        RadioGroupLabel,
        RadioGroupOption,
    },
    props: {
        title: String,
        options: Object,
        custom_class: String,

    }
}

</script>
